import { Box, Typography } from "@material-ui/core";
import { useFieldValue } from "formik";
import { FlexFieldController } from "../models/flexible/flex-field-controller";
import { GeneralFieldController } from "./general-field-controller";
import formatCurrency from "apps/platform-client/client/src/utils/currency-format";
import { LyfeTooltip } from "@lyfegen-platform/react-common";
import { dark } from "../hooks/use-map-theme-styles";
import { useTranslation } from "react-i18next";

function RenderValueCurrency(props: { controller: FlexFieldController; path: string }) {
	const [value] = useFieldValue(props.path);
	const currency = props.controller.parent.context.cases[0]?.baseAgreement.currency;
	const labelLocalizationKey = props.controller.schema.attribute.shortLabelLocalizationKey;
	const decimalPrecision = props.controller.schema.attribute.decimalPrecision;
	const { t } = useTranslation();

	return (
		<Box style={{ width: "48%" }} pr={5} paddingY={2.5} pl={1.5}>
			<Box>
				<Typography variant="caption" color="textSecondary">
					{t(labelLocalizationKey)}
				</Typography>
				<LyfeTooltip title={currency?.Name || ""}>
					<Typography style={{ color: dark, wordBreak: "break-word" }}>
						{formatCurrency(value, decimalPrecision, decimalPrecision)} {currency?.Code || ""}
					</Typography>
				</LyfeTooltip>
			</Box>
		</Box>
	);
}

export class InvoiceAmountFieldController extends GeneralFieldController {
	customRenderContent(path: string): React.ReactElement {
		return <RenderValueCurrency controller={this} path={path} />;
	}
}
